
<!--
  新建 退货退款的额外部分
  prop:
    contractId: 客户id

 -->

<template>
  <div class="add-refund" v-if="contractId">

    <div class="el-form" v-if="invoiceList.length">
      <h3 class="title">选择作废发票</h3>
      <div class="el-form-item">
        <label class="el-form-item__label">作废发票</label>
        <ul class="el-form-item__content">
          <li class="item" v-for="(item, index) in invoiceList" :class="{checked: checkedInvoices[index]}">
            <h4 class="tit">{{item.invoiceNo}}</h4>
            <p class="con"><span class="text">开票日期：{{item.invoiceDate}}</span></p>
            <p class="con"><span class="text">开票号码：{{item.invoiceNumber}}</span> {{item.amount}}元</p>
            <span class="checkbox" :class="{checked: checkedInvoices[index]}" @click="invoiceHandle(index, item.invoiceId)"></span>
          </li>
        </ul>
      </div>
    </div>

    <div class="el-form" v-if="paymentSheetList.length">
      <h3 class="title">关联回款单</h3>
      <div class="el-form-item">
        <label class="el-form-item__label">关联回款</label>
        <ul class="el-form-item__content">
          <li class="item" v-for="(item, index) in paymentSheetList" :class="{checked: checkedPaymentSheets[index]}">
            <h4 class="tit">{{item.sheetNo}}</h4>
            <p class="con"><span class="text">回款日期：{{item.paymentTime}}</span> {{item.amount | formatMoney}}元</p>
            <span class="checkbox" :class="{checked: checkedPaymentSheets[index]}" @click="paymentSheetHandle(index, item)"></span>
          </li>
        </ul>
      </div>
      <div class="el-form-item">
        <label class="el-form-item__label">合计退款金额(元)</label>
        <div class="el-form-item__content">
          <el-input 
            v-model.number="totalMoney" 
            @keyup.native="onInput(totalMoney)"
            placeholder="请输入退款金额" 
            :disabled="formatPaymentSheets.length > 0">
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
let lazy

export default {
  props: {
    form: Object,
    checkedInvoices: Array,
    checkedPaymentSheets: Array
  },
  created () {
    if (this.form.contractId) {
      this.contractId = this.form.contractId
    }
  },
  computed: {
    formatPaymentSheets () {
      return this.checkedPaymentSheets.filter(item => item)
    }
  },
  data () {
    return {
      invoiceList: [], // 发票列表
      paymentSheetList: [], // 退款单列表
      contractId: 0, // 合同id
      decimalPrecision: 2, // 合计退款金额精度
      totalMoney: 0
    }
  },
  methods: {

    // 初始化数据
    initData () {
      if (this.contractId) {
        this.getInvoice()
        this.getPaymentSheet()
      } else {
        this.invoiceList.length = 0
        this.paymentSheetList.length = 0
      }
    },

    // 获取关联发票列表
    getInvoice (id) {
      let url = '/refund/getInvoice.html'
      let params = {
        contractId: this.contractId.id
      }
      api.post(url, params, (data) => {
        this.invoiceList = data.invoiceList
      })
    },

    // 获取回款单列表
    getPaymentSheet (id) {
      let url = '/refund/getPaymentSheet.html'
      let params = {
        contractId: this.contractId.id
      }
      api.post(url, params, (data) => {
        this.paymentSheetList = data.paymentSheetList
        this.decimalPrecision = data.decimalPrecision

        this.countTotalMoney()
      })
    },

    // 选中发票
    invoiceHandle (index, id) {
      if (this.checkedInvoices[index]) {
        this.$set(this.checkedInvoices, index, undefined)
      } else {
        this.$set(this.checkedInvoices, index, id)
      }
    },

    // 选中回款单
    paymentSheetHandle (index, item) {
      if (this.checkedPaymentSheets[index]) {
        this.$set(this.checkedPaymentSheets, index, undefined)
      } else {
        this.$set(this.checkedPaymentSheets, index, item)
      }
      this.countTotalMoney()
    },

    // 超出小数位的处理
    onInput (value) {
      let inputValue = value.toString()
      if (inputValue.indexOf('.') !== -1) {
        var precisionLen = inputValue.split('.')[1].length // 获取input输入小数位的长度
        if (precisionLen > this.decimalPrecision) {
          let messageText = '限制了' + this.decimalPrecision + '位小数'
          Message({
            message: messageText,
            type: 'error'
          })
          // 如果小数位超出，则保留有效小数位
          this.totalMoney = inputValue.substr(0, inputValue.indexOf('.') + this.decimalPrecision + 1)
        }
      }
    },

    countTotalMoney () {
      let num = 0
      if (this.formatPaymentSheets.length) {
        this.formatPaymentSheets.forEach(item => {
          num += Number(item.amount)
        })
      } else {
        this.paymentSheetList.forEach(item => {
          num += Number(item.amount)
        })
      }
      num = Number(num.toFixed(this.decimalPrecision)) // 限制金额小数
      this.totalMoney = num
    }

  },

  filters: {
    formatMoney (num) {
      return num.toLocaleString()
    }
  },

  watch: {
    form: {
      handler (form) {
        clearTimeout(lazy)
        lazy = setTimeout(() => {
          this.contractId = form.contractId
        }, 50)
      },
      deep: true
    },
    contractId (val) {
      this.initData()
    },
    checkedPaymentSheets: {
      handler (arr) {
        arr = this.checkedPaymentSheets.filter(item => item)
      },
      deep: true
    },

    // 监听退款金额的变化
    totalMoney () {
      this.$emit('updateTotalMoney', this.totalMoney)
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  .add-refund {
    padding-right: 50px;
    .title {
      height: 24px;
      line-height: 24px;
      border-left: 4px solid @light-blue;
      color: @light-blue;
      padding-left: 12px;
      font-size: 15px;
      margin: 30px 0;
      .name {
        display: inline-block;
        vertical-align: top;
        width: 98px;
      }
    }
    .el-form-item__content {
      margin-left: 124px;
      .item {
        border:1px solid #dedede;
        border-radius:2px;
        padding: 0 5px;
        position: relative;
        margin-bottom: 10px;
        transition: all 0.3s;
        &.checked {
          border-color: #ff943e
        }
        &:last-child {
          margin-bottom: 0;
        }
        .tit, .con {
          font-size: 13px;
          line-height: 1;
          padding: 12px 4px;
        }
        .tit {
          border-bottom: 1px dashed #d8d8d8;
        }
        .con {
          color: @light-gray;
          text-align: right;
          overflow: hidden;
          .text {
            float: left;
          }
        }
        .con+.con {
          padding-top: 0;
        }
        .checkbox {
          display: inline-block;
          position: absolute;
          border: 1px solid #bfcbd9;
          border-radius: 4px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          background-color: #fff;
          cursor: pointer;
          z-index: 1;
          transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
          right: 10px;
          top: 8px;
          &:hover {
            border-color: #ff943e;
          }
          &:after {
            box-sizing: content-box;
            content: "";
            border: 2px solid #fff;
            border-left: 0;
            border-top: 0;
            height: 8px;
            left: 5px;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(0);
            width: 4px;
            transition: transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;
            transform-origin: center;
          }
          &.checked {
            background-color: #ff943e;
            border-color: @bg-orange;
            &:after {
              transform: rotate(45deg) scaleY(1);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// add-refund.vue?238eebd6